module.exports = __webpack_public_path__ + "img/view-sb.6ab57548.svg";